export const PDF_EXPORT_STYLES_PAGE_SIZE_DEFAULT = 'A4'
export const PDF_EXPORT_STYLES_PAGE_ORIENTATION_DEFAULT = 'portrait'
export const PDF_EXPORT_STYLES_FONT_SIZE_DEFAULT = 11

export const PDF_EXPORT_STYLES_PAGE_SIZE_LIST = [
    {value:'A1',label:'A1'},
    {value:'A2',label:'A2'},
    {value:'A3',label:'A3'},
    {value:'A4',label:'A4'},
    {value:'A5',label:'A5'},
    {value:'A6',label:'A6'},
    {value:'A7',label:'A7'},
    {value:'A8',label:'A8'},
    {value:'A9',label:'A9'},
    {value:'A10',label:'A10'},
]



export const PDF_EXPORT_STYLES_PAGE_ORIENTATION_LIST = [
    {value:'portrait',label:'portrait'},
    {value:'landscape',label:'landscape'},
]

export const PDF_EXPORT_STYLES_FONT_SIZE = [
    {value: '8', label: '8'},
    {value: '9', label: '9'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
    {value: '14', label: '14'},
    {value: '16', label: '16'},
    {value: '18', label: '18'},
    {value: '20', label: '20'},
    {value: '22', label: '22'},
    {value: '24', label: '24'},
    {value: '26', label: '26'},
    {value: '28', label: '28'},
    {value: '36', label: '36'},
    {value: '48', label: '48'},
    {value: '72', label: '72'},

]